import * as React from 'react';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import { VehiclesPage } from '&/features/settings/vehicles/pages/vehicles-page';

export const Route = createFileRoute('/_authenticated/settings_/spaces/$spaceId/vehicles')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['spaces:manage', 'spaces:access-read-only'])
    ) {
      throw redirect({ params: { spaceId: params.spaceId }, to: '/settings/spaces/$spaceId' });
    }
  },
  component: SpaceVehiclesPage,
});

function SpaceVehiclesPage(): React.JSX.Element {
  const { spaceId } = useParams({ from: '/_authenticated/settings_/spaces/$spaceId/vehicles' });
  return <VehiclesPage scope="space" spaceId={spaceId} />;
}
